<template>
  <!-- <el-select filterable v-model="id" placeholder="选择科目" size="mini">
    <el-option style="color:red" label="新增+" value="add"></el-option>
    <el-option
      v-for="item in subjectListOldList"
      :key="item.sign"
      :label="item.name3"
      :value="item.sign"
    >
    <span style="float: left">{{ item.name3 }}</span>
    <span style="float: right;color: red;font-size: 14px;">{{item.fzhsItemName}}</span>

    </el-option>
  </el-select> -->

  <el-select :class="{border_none:borderNone}" @change="changeSelect" size="mini" clearable filterable v-model="id" placeholder="请选择">
    <el-option-group
      v-for="group in options"
      :key="group.label"
      :label="group.label">
      <el-option
        v-for="item in group.options"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-option-group>
  </el-select>


  <add-inventory @success="addSuccess" ref="addInventory"></add-inventory>
  <!-- <inventory-list inventoryName="xxx" v-model:inventoryId="a" v-model:inventoryType="b" :type="true"></inventory-list> -->
</template>
<script>
export default {
  props:{
    type: {//是否使用服务
      type: Boolean,
      default: false
    },
    inventoryId: {
      type: Number,
      default: 0
    },
    inventoryName: {//默认新增存货名称
      type: String,
      default: ""
    },
    inventorySpec: {//默认新增存货型号
      type: String,
      default: ""
    },
    inventoryUnit: {//默认新增存货单位
      type: String,
      default: ""
    },
    inventoryType: {//存货还是服务  inventory service
      type: String,
      default: ""
    },
    borderNone:{
      type:Boolean,
      default:false
    }
  },
  computed: {
    options(){
      let inventorys = this.$store.getters["commons/inventorys"]
      let options = []
      if(inventorys.services && this.type){
        options.push({
          label: "服务",
          options: inventorys.services,
        })
      }
      options.push({
        label: '',//不填 新增存货
        options: [{
          id: "add",
          name: '+新增存货',
        }]
      })
      if(inventorys.inventoryYcl){
        options.push({
          label: "原材料",
          options: inventorys.inventoryYcl,
        })
      }
      if(inventorys.inventoryKcsp){
        options.push({
          label: "库存商品",
          options: inventorys.inventoryKcsp,
        })
      }

      if(inventorys.inventoryBcp){
        options.push({
          label: "半成品",
          options: inventorys.inventoryBcp,
        })
      }

      if(inventorys.inventoryBzw){
        options.push({
          label: "包装物",
          options: inventorys.inventoryBzw,
        })
      }
      return options 
    },
    id: {
      get() {
        if(!this.inventoryId){
          return ""
        }
        return this.inventoryId
      },
      set(val) {
        if(val == 'add'){
          let data = {
            id: undefined,
            name: this.inventoryName,
            spec: this.inventorySpec,
            unit: this.inventoryUnit,
            type: 2,
          }
          this.$refs.addInventory.init(data)
          val = undefined
          return
        }
        this.$emit("update:inventoryId", val)
        if(val <= 10){
          this.$emit("update:inventoryType", 'service')
        }else{
          this.$emit("update:inventoryType", 'inventory')
        }

        let info = {}
        this.options.map(v=>{
          v.options.map(z=>{
            if(z.id == val){
              info = z
            }
          })
        })
        this.$emit("update:spec", info.spec)
        this.$emit("update:unit", info.unit)
        this.$emit("success", val)
      }
      
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    addSuccess(e){
      this.id = e.id
    },
  }
}
</script>